import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Floor } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FloorService {
  private apiService = inject(ApiService);

  storeFloor(data: Floor) {
    data.isParking === true ? (data.isParking = 1) : (data.isParking = 0);
    return this.apiService.store('floor', data);
  }

  deleteFloor(id: number) {
    return this.apiService.delete('floor', id);
  }

  getFloors(): Observable<Floor[]> {
    return this.apiService.getAll('');
  }

  getFloorsByBuilding(building: number): Observable<any> {
    return this.apiService.getAll(`floor/ByBuildingWithNoMap/${building}`);
  }

  getFloorMap(floor: string): Observable<any> {
    return this.apiService.get(`floor/floorMap/${floor}`);
  }

  getFloor(id: number): Observable<Floor> {
    return this.apiService.getById('', id);
  }

  updateFloor(data: Floor, id: number) {
    data.isParking === true ? (data.isParking = 1) : (data.isParking = 0);
    return this.apiService.put('floor', data, id);
  }
}
